import React from 'react'
import { Trans } from 'react-i18next'
import styles from './lowConfidenceText.module.scss'
import BtnPrimary from 'components/generic/BtnPrimary'
import { useModalDispatch, useModalState } from 'hooks/use-modal'
import { CONFIDENCE_MODAL_ID } from 'components/profile/modals/ConfidenceModal'

const LowConfidenceText = () => {
  const { modalActions, modalDispatch } = useModalDispatch(CONFIDENCE_MODAL_ID as never)
  const { isOpen } = useModalState(CONFIDENCE_MODAL_ID as never)

  return (
    <div className={styles.textContainer}>
      <Trans ns='strH2H' i18nKey='winLikelihood.lowConfidence'>
        <p className={styles.text}>
          Both players must have verified World Tennis Numbers for an accurate prediction to
          display.
        </p>{' '}
        <BtnPrimary
          linkStyle
          onClick={() => modalDispatch(modalActions.openModal())}
          className={styles.text}
          buttonProps={{
            'aria-expanded': isOpen,
          }}
        >
          Understanding verification
        </BtnPrimary>
      </Trans>
    </div>
  )
}

export default LowConfidenceText
